import EventSourseClass from "@/plugins/sse"

export default function configureServerNotificationEvent() {
  return new EventSourseClass("sse")
}
